import React, { useState } from 'react'
import styled from 'styled-components'
import { Player } from '@lottiefiles/react-lottie-player';

const SwapLoader: React.FC = () => {
  return (
        <Player
        autoplay={!false}
        loop={!false}
        controls={false}
        src="https://assets7.lottiefiles.com/packages/lf20_nt9epz.json"
        style={{ height: '270px', width: '270px' }}
      />
  )
}

export default SwapLoader
